var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var DoneIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("polygon", { fillRule: "evenodd", points: "9.091 15.536 5.273 11.718 4 12.991 9.091 18.082 20 7.173 18.727 5.9" }))); };
export default DoneIcon;
